import { useEffect, useState } from 'react';

type AuthStepPanelProps = {
  title?: string;
  description?: string;
  animationKey: string;
  children: React.ReactNode;
};

export const AuthStepPanel = ({
  title,
  description,
  animationKey,
  children,
}: AuthStepPanelProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const hasHeaderText = Boolean(title || description);

  useEffect(() => {
    setIsVisible(false);
    const frame = window.requestAnimationFrame(() => {
      setIsVisible(true);
    });

    return () => window.cancelAnimationFrame(frame);
  }, [animationKey]);

  return (
    <div
      className={`rounded-[1.75rem] bg-transparent p-5 transition-all duration-300 ease-out md:p-6 ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-6 opacity-0'
      }`}
    >
      <div className={hasHeaderText ? 'mb-4' : 'mb-0'}>
        {hasHeaderText && (
          <div className="max-w-[28rem]">
            {title && (
              <h3 className="font-recoleta text-[2rem] leading-tight text-white md:text-[2.25rem]">
                {title}
              </h3>
            )}
            {description && <p className="mt-2 font-termina text-sm text-white/72">{description}</p>}
          </div>
        )}
      </div>

      {children}
    </div>
  );
};
